import React from 'react'
import { useSelector } from 'react-redux';

function ExchangeContainer() {
  const { currentLocal } = useSelector((state) => state.currentLocal);


    return (
        <section className='contact_container'>
            <div className='contact_box'>
                <h5 className='text-center fw-bold mb-3'>{currentLocal.home.Exchange}</h5>
{currentLocal && currentLocal.language === "English" ?
<p>

1. Return or exchange within 14 days from the date of receipt of the order, provided the product is in its original condition, unopened, unused, or damaged.<br/><br/>
2. For health and safety reasons, no cosmetic or skincare product may be returned or exchanged once opened or used.<br/><br/>
3. If you receive a damaged or non-conforming product, please contact us within 48 hours of receipt. It will be replaced or fully refunded at no additional cost.<br/><br/>
4. Shipping Costs:
◦ In the event of a return or exchange due to an error on our part (wrong/damaged product), the company will bear the full shipping costs.
◦ In the event of a return or exchange based solely on the customer's request, the customer will bear the shipping costs.<br/><br/>

5. Refunds will be transferred within 7–14 business days using the same payment method used at the time of purchase.<br/><br/>
6. Proof of purchase (invoice or order number) is required when requesting a return or exchange.
</p>
:
<div>
<p>

	1	الاسترجاع أو الاستبدال خلال 14 يومًا من تاريخ استلام الطلب، بشرط أن يكون المنتج في حالته الأصلية غير مفتوح أو مستخدم أو تالف.<br/><br/>
	2	لا يُمكن استرجاع أو استبدال أي منتج من مستحضرات التجميل أو العناية بالبشرة بعد فتحه أو استخدامه، حفاظًا على الصحة والسلامة.<br/><br/>
	3	في حالة استلام منتج تالف أو غير مطابق للطلب، نرجو التواصل معنا خلال 48 ساعة من الاستلام، وسيتم استبداله أو استرداد قيمته بالكامل دون أي رسوم إضافية.<br/><br/>
	4	تكاليف الشحن: 
	◦	في حالة الاسترجاع أو الاستبدال بسبب خطأ من جانبنا (منتج خاطئ/تالف)، تتحمل الشركة تكاليف الشحن كاملة.
	◦	في حالة الاسترجاع أو الاستبدال لرغبة العميل فقط، يتحمل العميل تكاليف الشحن.<br/><br/>
	
	5	المبالغ المستردة يتم تحويلها خلال 7 – 14 يوم عمل بنفس وسيلة الدفع المستخدمة عند الشراء. <br/><br/>
	6	يُشترط تقديم إثبات الشراء (فاتورة أو رقم الطلب) عند طلب الاسترجاع أو الاستبدال.</p>

</div>

}
            </div>
        </section>)
}

export default ExchangeContainer